export interface QuickReply {
  id: string;
  title: string;
  category: string;
  message: string;
  changeStatusTo?: string;
}

export const QUICK_REPLIES: QuickReply[] = [
  {
    id: 'cancelamento-prazo',
    title: 'Cancelamento dentro do prazo',
    category: 'Cancelamento',
    message:
      'Olá, {nome}! Para solicitar o cancelamento do seu pedido, a solicitação deve ser feita diretamente por você no site ou aplicativo da Banca do Ingresso. O cancelamento é permitido em até 7 dias corridos após a compra, conforme o direito de arrependimento previsto no art. 49 do Código de Defesa do Consumidor. Além disso, o evento precisa estar a mais de 24 horas de acontecer. Após a aprovação, o reembolso é realizado pela mesma forma de pagamento e o prazo pode variar conforme a instituição financeira.',
    changeStatusTo: 'Aguardando Cliente',
  },
  {
    id: 'cancelamento-fora-prazo',
    title: 'Cancelamento fora do prazo',
    category: 'Cancelamento',
    message:
      'Olá, {nome}! Verificamos sua solicitação. Conforme a legislação vigente, o cancelamento por arrependimento para compras online deve ser solicitado em até 7 dias corridos após a compra. Como sua solicitação foi feita após esse prazo, infelizmente não é possível seguir com o cancelamento pela plataforma.',
    changeStatusTo: 'Resolvido',
  },
  {
    id: 'cancelamento-evento-proximo',
    title: 'Cancelamento - evento próximo',
    category: 'Cancelamento',
    message:
      'Olá, {nome}! Quando o evento acontece em menos de 7 dias a partir da data da compra, o cancelamento pode ser solicitado com até 48 horas de antecedência da realização do evento. Solicitações feitas fora desse prazo ou no dia do evento não podem ser aceitas.',
    changeStatusTo: 'Aguardando Cliente',
  },
  {
    id: 'reembolso-cartao',
    title: 'Reembolso no cartão',
    category: 'Reembolso',
    message:
      'Olá, {nome}! Para pagamentos realizados no cartão de crédito, o reembolso é processado entre 30 e 40 dias após a confirmação do cancelamento. O valor poderá aparecer na fatura atual ou na próxima, de acordo com a data de fechamento definida pelo banco emissor do cartão.',
    changeStatusTo: 'Aguardando Cliente',
  },
  {
    id: 'reembolso-pix',
    title: 'Reembolso via PIX',
    category: 'Reembolso',
    message:
      'Olá, {nome}! Para pagamentos realizados via PIX, o reembolso é efetuado entre 20 e 30 dias após a confirmação do cancelamento. O valor será devolvido na conta bancária utilizada no pagamento.',
    changeStatusTo: 'Aguardando Cliente',
  },
  {
    id: 'transferencia-regras',
    title: 'Regras de transferência',
    category: 'Transferência',
    message:
      'Olá, {nome}! A transferência de ingressos segue algumas regras: o favorecido precisa possuir conta válida e já validada na Banca do Ingresso, a transferência pode ser feita até 3 horas antes do início do evento, cada ingresso só pode ser transferido uma única vez e, após a conclusão, ele ficará disponível apenas na conta do favorecido.',
    changeStatusTo: 'Aguardando Cliente',
  },
  {
    id: 'transferencia-passo-a-passo',
    title: 'Como transferir ingresso',
    category: 'Transferência',
    message:
      'Olá, {nome}! Para transferir um ingresso, acesse sua conta na Banca do Ingresso, vá até a aba de ingressos no aplicativo, selecione a opção de transferência e informe o CPF da pessoa favorecida. A transferência só será concluída se essa pessoa possuir uma conta válida na plataforma.',
    changeStatusTo: 'Aguardando Cliente',
  },
  {
    id: 'instabilidade-pagamento',
    title: 'Instabilidade no pagamento',
    category: 'Pagamento',
    message:
      'Olá, {nome}! Identificamos uma instabilidade momentânea no processamento de algumas compras. Em alguns casos, o pagamento foi concluído, mas o ingresso pode ter ficado temporariamente com status incorreto no sistema. Nossa equipe já está atuando na regularização e, se o pagamento foi aprovado, a atualização será feita.',
    changeStatusTo: 'Aguardando Cliente',
  },
  {
    id: 'evento-responsabilidade-produtor',
    title: 'Informações do evento',
    category: 'Evento',
    message:
      'Olá, {nome}! As orientações específicas do evento, incluindo regras de acesso, realização, cancelamento, adiamento e demais condições, são definidas pelo produtor do evento. Recomendamos sempre verificar as informações disponíveis na página do evento.',
    changeStatusTo: 'Aguardando Cliente',
  },
  {
    id: 'meia-entrada-validacao-previa',
    title: 'Validação prévia de documento',
    category: 'Evento',
    message:
      'Olá, {nome}! A validação definitiva do documento de meia-entrada ocorre no momento do acesso ao evento, mediante apresentação do comprovante exigido. Por esse motivo, não conseguimos realizar uma aprovação formal prévia pelo atendimento.',
    changeStatusTo: 'Resolvido',
  },
  {
    id: 'atendimento-encerrado',
    title: 'Encerrar atendimento',
    category: 'Encerramento',
    message:
      'Olá, {nome}! Seu atendimento foi finalizado. Caso precise de novo suporte, estaremos à disposição pelos nossos canais oficiais.',
    changeStatusTo: 'Fechado',
  },
];
